interface Props {
  status: string;
}

const LABELS: Record<string, string> = {
  new: "New",
  interested: "Interested",
  follow_up: "Follow-up",
  not_interested: "Not Interested",
  converted: "Converted",
  lost: "Lost",
};

export function StatusPill({ status }: Props) {
  const label = LABELS[status] ?? status;
  return <span className={`pill pill-${status}`}>{label}</span>;
}
